import React from 'react';
import LoadingWrapper from '../../hocs/LoadingWrapper';
import Body from './Body';

const TimetableView = ({
    scroll,
    fetching,
    selectedDay,
    favoriteArtists = [],
    isLiveView,
    goToNow,
    nowOffset,
    updateNow,
    showNow,
    maxHour,
    selectedPartner,
    minHour,
    hourIntervals,
    stages,
    filtersOpen,
    showEntry,
    onScroll,
    artistsFilters,
    favOrUnfavArtist,
    liveFilters,
    zoom,
    nonLinearFilters
}) => (
    <div className={`ckp-timetable ${filtersOpen ? 'is-with-filters' : ''}`}>
        <LoadingWrapper show={fetching} className="is-big" label="Loading timetable..." size={40}>
            <React.Fragment>
                <Body
                    favOrUnfavArtist={favOrUnfavArtist}
                    favoriteArtists={favoriteArtists}
                    artistsFilters={artistsFilters}
                    liveFilters={liveFilters}
                    nonLinearFilters={nonLinearFilters}
                    isLiveView={isLiveView}
                    goToNow={goToNow}
                    nowOffset={nowOffset()}
                    updateNow={updateNow}
                    showNow={showNow}
                    maxHour={maxHour}
                    selectedPartner={selectedPartner}
                    scrollX={scroll.x}
                    day={selectedDay}
                    minHour={minHour}
                    hours={hourIntervals}
                    stages={stages}
                    onScroll={onScroll}
                    showEntry={showEntry}
                    zoom={zoom}
                />
            </React.Fragment>
        </LoadingWrapper>
    </div>
);

export default TimetableView;



// WEBPACK FOOTER //
// ./src/components/application/timetable/TimetableView.js